export function getCategory(data, targetId) {
  for (const item of data) {
    // Check if the current item has the target value
    if (item.id === targetId) {
      return item;
    }

    // Check if the current item has children, then recursively search in children
    if (item.children_data && item.children_data.length > 0) {
      const result = getCategory(item.children_data, targetId);
      if (result) {
        return result;
      }
    }
  }
  // If the target value is not found in the current level or its children, return null
  return null;
}

export const modifyMegaMenuTreeData = (array) => {
  return array?.filter(
    (cat) =>
      cat.is_active &&
      cat.include_in_megamenu &&
      // cat.include_in_menu === "1" &&
      cat.product_count > 0
  );
};

export const modifyTopThisWeekData = (array) => {
  return array?.filter(
    (cat) => cat.is_active && cat.top_this_week && cat.product_count > 0
  );
};

export const modifyMenuTreeData = (array) => {
  return (array || [])?.filter(
    (cat) =>
      cat.is_active &&
      // cat.include_in_menu === "1" &&
      cat.product_count > 0
  );
};

export const getFullCategoryUrl = (category, allCategoriesTree) => {
  // Find the parent category in the allCategoriesTree array
  const parentCategory = allCategoriesTree.find(
    (cat) => cat.id === category.parent_id
  );

  // If there is a parent, recursively get its URL
  if (parentCategory) {
    return `${getFullCategoryUrl(parentCategory, allCategoriesTree)}/${category.url_key}`;
  } else {
    // If there's no parent (root level category), just return the category's url_key
    return `/${category.url_key}`;
  }
};

export function extractAllIncludeInNavBarData(data) {
  const result = [];

  (data || []).forEach((cat) => {
    if (cat.is_active && cat.include_in_megamenu && cat.product_count > 0) {
      result.push(cat);
    }

    if (Array.isArray(cat.children_data) && cat.children_data.length > 0) {
      const children = extractAllIncludeInNavBarData(cat.children_data);
      if (children?.length) {
        result.push(...children);
      }
    }
  });

  return result;
}
